export default __webpack_public_path__ + "static/2.2_DE-2fd84195f74a089b07561fd493d16104.webp";